module.exports = __webpack_public_path__ + "static/media/navigate-icon-right.de31fea7.svg";